
import React, { useState } from "react";
import Calendar from "react-calendar";
import Card from "components/card";
import "react-calendar/dist/Calendar.css";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import "assets/css/MiniCalendar.css";

const MiniCalendar = () => {
  const [value, onChange] = useState(new Date());

  return (
    <Card extra="flex w-full h-full flex-col px-3 py-3">
      <Calendar
        onChange={onChange}
        value={value}
        prevLabel={<MdChevronLeft className="ml-1 h-6 w-6 text-gray-600 dark:text-white" />}
        nextLabel={<MdChevronRight className="ml-1 h-6 w-6 text-gray-600 dark:text-white" />}
        view="month"
        className="custom-calendar"
        navigationLabel={({ date, label }) => (
          <div
            style={{
              background: "none",   // remove hover background
              cursor: "default",    // keep pointer normal
              padding: "0.25rem 0.5rem",
              borderRadius: "0.25rem",
            }}
          >
            {label}
          </div>
        )}
      />

    </Card>
  );
};

export default MiniCalendar;
